import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';
import {useMenu, findParent} from '../../../hooks/useMenu';

function TotalFullBody({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);
  const {selected, items} = useMenu();
  const parent = findParent(null, items, selected);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title={parent.name}
      fullCaption="None............0.0f...............................
      .........................................................
      .........................................................
      .........................................................
      .........................................................
      .........................................................
      "
    />
  );
}

export default TotalFullBody;
